var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"llp-container-section heightcontainer"},[_c('div',[_c('top-header',{attrs:{"id":"height2"}}),_c('main-menu',{attrs:{"id":"height3"}})],1),_c('employee',{staticStyle:{"padding-left":"0px","padding-right":"0px"},attrs:{"id":"employee"}}),_c('bottom-footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }